export default __webpack_public_path__ + "static/media/ambient-bright-green-yellow.65a3c5cb.jpg";